import { combineReducers } from 'redux'
import servants from './servants'

export default combineReducers({servants})



// WEBPACK FOOTER //
// ./src/reducers/index.js